import { useState, useEffect, useCallback } from "react"
import { useNavigate, Link } from "react-router-dom";
import classes from "./styles.module.scss";
import ButtonSecondary from "../../components/buttonSecondary";
import Logo from "../../assets/images/image 967.png";
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import BrightnessMediumIcon from '@mui/icons-material/BrightnessMedium';
import LanguageIcon from '@mui/icons-material/Language';
import AccessibleIcon from '@mui/icons-material/Accessible';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useTranslation } from "../../context/language";

const LoginHeaderComponents = () => {
  const [langList, setLangList] = useState(false);
  const [selectedLang, setSelectedLang] = useState("हिन्दी");
  const { setLanguage, } = useTranslation();

  // let time = new Date().toLocaleString("en-US", {
  //   hour: "numeric",
  //   minute: "numeric",
  //   hour12: true,
  // });

  // // Detect current language from cookie on mount
  // useEffect(() => {
  //   const getCookie = (name) => {
  //     const value = `; ${document.cookie}`;
  //     const parts = value.split(`; ${name}=`);
  //     if (parts.length === 2) return parts.pop().split(";").shift();
  //     return null;
  //   };

  //   const googtrans = getCookie("googtrans");
  //   if (googtrans && googtrans.includes("/hi")) {
  //     setSelectedLang("हिन्दी");
  //   } else {
  //     setSelectedLang("English");
  //   }
  // }, []);

  const handleLangList = () => {
    setLangList(!langList);
  };
  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    setSelectedLang(lang === "en" ? "English" : "हिन्दी");
    setLangList(false);
  };

  // // Programmatically trigger Google Translate language switch
  // const triggerGoogleTranslate = useCallback((langCode) => {
  //   // Set the googtrans cookie for the selected language
  //   const setCookie = (name, value) => {
  //     document.cookie = `${name}=${value}; path=/`;
  //     document.cookie = `${name}=${value}; path=/; domain=${window.location.hostname}`;
  //   };

  //   if (langCode === "en") {
  //     // Remove translation - reset to original
  //     setCookie("googtrans", "");
  //     setSelectedLang("English");
  //   } else {
  //     setCookie("googtrans", `/en/${langCode}`);
  //     setSelectedLang(langCode === "hi" ? "हिन्दी" : langCode);
  //   }

  //   // Try to trigger Google Translate widget's internal select
  //   const gtSelect = document.querySelector(".goog-te-combo");
  //   if (gtSelect) {
  //     gtSelect.value = langCode;
  //     gtSelect.dispatchEvent(new Event("change"));
  //   } else {
  //     // If the widget hasn't loaded yet, reload after setting cookie
  //     window.location.reload();
  //   }

  //   setLangList(false);
  // }, []);



  const scrollToContent = () => {
    const mainContent = document.getElementById("main-content");
    if (mainContent) {
      mainContent.scrollIntoView({ behavior: "smooth" });
      mainContent.focus();
    }
  };

  return (
    <div className={classes.wrapper_container}>
      {/* Hidden Google Translate element - required for the widget to work */}
      <div id="google_translate_element" style={{ display: "none" }}></div>

      <div className={classes.main_header}>

        <div className={classes.first_line} >

          <div className={classes.left_date_time}>
            <p className={classes.date_time}>
              <span className={classes.text_white}>
                Government of Bihar
              </span>
            </p>
          </div>
          <div className={classes.right_actions}>
            <span
              onClick={scrollToContent}
              className={classes.skip_button}
            >
              Skip to Main Content
            </span>
            <span className={classes.divider}>|</span>

            {/* <div className={classes.icon_text_button}>
              <RecordVoiceOverIcon className={classes.mui_icon} />
              <span className={classes.text_white}>Screen Reader</span>
            </div> */}
            {/* <span className={classes.divider}>|</span> */}

            {/* <div className={classes.zoom}>
              <span className={classes.zoom_text}>A-</span>
              <span className={classes.zoom_text}>A</span>
              <span className={classes.zoom_text}>A+</span>
            </div> */}
            {/* <span className={classes.divider}>|</span>

            <div className={classes.icon_wrapper}>
              <BrightnessMediumIcon className={classes.mui_icon} />
            </div> */}

            {/* <span className={classes.divider}>|</span> */}

            <div className={classes.select_language}>
              <div
                className={classes.selected_language}
                onClick={handleLangList}
              >
                <LanguageIcon className={classes.mui_icon} />
                <span className={classes.text_white}>{selectedLang}</span>
                <KeyboardArrowDownIcon className={classes.mui_icon} />
              </div>
              {
                langList &&
                <div className={classes.language_list}>
                  <ButtonSecondary
                    button_text="हिन्दी"
                    second_className={classes.p}
                    onClick={() => handleLanguageChange("hi")}
                  />
                  <ButtonSecondary
                    button_text="English"
                    second_className={classes.p}
                    onClick={() => handleLanguageChange("en")}
                  />
                </div>
              }
            </div>

            {/* <div className={classes.icon_text_button}>
              <AccessibleIcon className={classes.mui_icon} />
              <span className={classes.text_white}>More</span>
            </div> */}
          </div>
        </div>

        <div className={classes.second_line} >
          <div className={classes.second_line_left}>
          </div>
          <div className={classes.second_line_right}>
            <p className={classes.text_white}>
              18003454417 / 14417 <span style={{ color: "#F8B133" }}>|</span> (10AM to 5PM, Monday to Saturday)
            </p>
            <Link to={"mailto:rtebiharhelp@gmail.com"} className={`${classes.text_white_mail} hover:underline hover:color:"#F8B133 !important"`}>rtebiharhelp@gmail.com</Link>

          </div>
        </div>

        {/* <div className={classes.third_line}>
          <div className={classes.left_logo}>
            <Link to={"/"}>
              <div className={classes.brand_logo_text}>
                <img src={Logo} alt="brand_image" />
                <p className={classes.text}>
                  <span>Gyandeep</span>
                  <span>Right to Education</span>
                </p>
              </div>
            </Link>
          </div>
          <div className={classes.third_line_right_options} >
            <ul>
              <li>
                <Link
                  to={"https://prod-1.static.codebuckets.in/file/codebucket-production-public/doe-gyandeep/RTE%20%202026-27%20Admission%20Guideline.pdf"}
                  className={classes.header_btn}
                  target="_blank"
                ><span className={classes.new_label}>new</span>2026-27 Admission Guideline
                </Link>
              </li>
              <li>
                <Link to="/registration/school-details-page" className={classes.header_btn}>
                  <span className={classes.new_label}>new</span>Check School List
                </Link>
              </li>

              <li>
                <a
                  href="http://edu-online.bihar.gov.in/RtiReg/index.Html"
                  target="_blank"
                  rel="noreferrer"
                  className={classes.header_btn}
                ><span className={classes.new_label}>new</span>E-sambandhan Portal</a>
              </li>

              <li>
                <Link to="/registration/application" className={classes.header_btn}>
                  Get Application
                </Link>
              </li>

              <li>
                <Link to="/" className={classes.header_btn}>
                  Student Registration
                </Link>
              </li>
            </ul>
          </div>
        </div> */}

      </div>
    </div>
  );
};

export default LoginHeaderComponents;